var _a;
import { PurposeBuilding as ServerPurposeBuilding } from '@api-gen';
import { createDataRecordConverter } from '@core/utils/helpers';
import { PurposeBuilding as ClientPurposeBuilding } from '@features/constructor/types';
export var purposeBuildingMap = createDataRecordConverter((_a = {},
    _a[ClientPurposeBuilding.LargePanelBuilding] = ServerPurposeBuilding.LargePanelBuilding,
    _a[ClientPurposeBuilding.FramePanelBuilding] = ServerPurposeBuilding.FramePanelBuilding,
    _a));
export var convertToServerPurposeBuildingData = function (type) {
    return purposeBuildingMap.toServer[type];
};
export var convertToClientPurposeBuildingData = function (type) {
    return purposeBuildingMap.toClient[type];
};
